import { useEffect } from "react";

// Burn-in care for wall displays: every few minutes the whole app moves to the next
// spot on a small loop around where it belongs, never more than 2 px away. Too little
// to notice, but the rail, the clock and the widget edges don't sit on the same pixels
// all day. The offsets are CSS variables the app and the screensaver clock read (sleep.css).

const STEP_MS = 3 * 60_000;
const LOOP: readonly (readonly [number, number])[] = [
  [0, 0],
  [1, 0],
  [2, 1],
  [1, 2],
  [0, 2],
  [-1, 1],
  [-2, 0],
  [-1, -1],
  [0, -2],
  [1, -1],
];

/** The offset in pixels for a given step. */
export function shiftFor(step: number): { x: number; y: number } {
  const [x, y] = LOOP[((step % LOOP.length) + LOOP.length) % LOOP.length]!;
  return { x, y };
}

export function usePixelShift(enabled: boolean) {
  useEffect(() => {
    const root = document.documentElement.style;
    if (!enabled) {
      root.removeProperty("--shift-x");
      root.removeProperty("--shift-y");
      return;
    }
    const apply = () => {
      const { x, y } = shiftFor(Math.floor(Date.now() / STEP_MS));
      root.setProperty("--shift-x", `${x}px`);
      root.setProperty("--shift-y", `${y}px`);
    };
    apply();
    const t = window.setInterval(apply, 30_000);
    return () => {
      clearInterval(t);
      root.removeProperty("--shift-x");
      root.removeProperty("--shift-y");
    };
  }, [enabled]);
}
